import { render, staticRenderFns } from "./BusinessTabs.vue?vue&type=template&id=6fac7db5"
var script = {}
import style0 from "./BusinessTabs.vue?vue&type=style&index=0&id=6fac7db5&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./BusinessTabs.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports